// BookThatApp renders its calendar in a same-origin srcdoc iframe, so theme CSS can't reach it.
// Injecting here keeps the restyle scoped to this theme instead of changing the app's store-wide settings.
(() => {
  const CSS = `
    body { background: transparent !important; }
    .sub-panel { background: #f1f1f0 !important; box-shadow: none !important; border: 0 !important; border-radius: 8px !important; }
    .widget-title { display: none !important; }
    .widget-container, .widget-container > div { max-width: none !important; width: 100% !important; padding: 0 !important; margin: 0 !important; }
    .sub-panel { width: 100% !important; max-width: none !important; margin: 0 !important; box-sizing: border-box !important; padding: 24px !important; }
    .rdp-caption_label { font-weight: 600 !important; font-size: 14px !important; color: #1d1d1b !important; }
    .rdp-nav_button { color: #1d1d1b !important; }
    .rdp-head_row { background: transparent !important; }
    .rdp-head_cell { font-size: 11px !important; font-weight: 500 !important; color: #1d1d1b !important; text-transform: uppercase; }
    .rdp-row + .rdp-row .rdp-cell, .rdp-tbody .rdp-row:first-child .rdp-cell { border-top: 1px solid #e4e4e2; }
    .rdp-day { font-size: 12px !important; color: #1d1d1b !important; border-radius: 999px !important; }
    .rdp-day_disabled, .rdp-day_outside { color: #a9a9a5 !important; }
    .rdp-day_selected, .rdp-day_selected:hover, .rdp-day_selected:focus { background: #8c7b6b !important; color: #fff !important; }
    .bta-react-select__control { border-color: #d9d9d6 !important; border-radius: 6px !important; box-shadow: none !important; }
    .bta-react-select__single-value { background: transparent !important; color: #1d1d1b !important; }
    .sub-panel > button:last-of-type:not([disabled]) { background: #1d1d1b !important; color: #fff !important; border-radius: 12px !important; height: 40px !important; min-height: 40px !important; padding-top: 0 !important; padding-bottom: 0 !important; font-family: Inter, sans-serif !important; font-weight: 400 !important; font-size: 16px !important; line-height: 1.5 !important; letter-spacing: 0.02em !important; text-transform: uppercase !important; }
    .sub-panel > button:last-of-type:not([disabled]):hover { background: #000 !important; color: #fff !important; }
  `;

  const inject = (frame) => {
    try {
      const doc = frame.contentDocument;
      if (!doc || !doc.head || doc.getElementById('o2-bta')) return;
      const style = doc.createElement('style');
      style.id = 'o2-bta';
      style.textContent = CSS;
      doc.head.appendChild(style);
    } catch (e) {
      // Cross-origin frame — leave the app's default styling.
    }
  };

  const scan = () => {
    document.querySelectorAll('[id^="bta-"] iframe').forEach((frame) => {
      inject(frame);
      if (!frame.dataset.o2Bound) {
        frame.dataset.o2Bound = '1';
        frame.addEventListener('load', () => inject(frame));
      }
    });
  };

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
